import React, { useState } from "react";
import ReactSelect, { components } from "react-select";
import { CountryCode, CountryImages } from "../../Utils/Constants";
import { skills } from "../../Constants/taskers";
import "./index.css";

const countryCodeOptions = [...new Set(Object.values(CountryCode))].map(
  (countrycode) => Object({ value: countrycode, label: countrycode })
);

const Option = (props) => {
  const { data } = props;
  return (
    <components.Option {...props}>
      <img
        src={CountryImages[data.label]}
        width="25"
        height="25"
        alt="country-code"
      />
      {data.label}
    </components.Option>
  );
};

const InviteTaskerModal = ({ addTasker }) => {
  const [firstName, setFirstName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState({
    value: "+44",
    label: "+44",
  });
  const [taskerSkill, setTaskerSkill] = useState(null);
  const handleOnChangeFirstName = ({ target }) => {
    setFirstName(target.value);
  };
  const handleOnChangePhoneNumber = ({ target }) => {
    setPhoneNumber(target.value);
  };
  const handleAddTasker = () => {
    setFirstName("");
    setPhoneNumber("");
    setTaskerSkill(null);
    addTasker({
      firstName,
      phoneNumber: `${countryCode.value}${phoneNumber}`,
      skill: taskerSkill.value,
    });
  };

  const handleCountryCode = (countryCode) => {
    setCountryCode(countryCode);
  };

  const handleChangeSkill = (value) => {
    setTaskerSkill(value);
  };
  return (
    <div
      className="modal fade"
      id="invite_tasker"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Invite Tasker</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="First Name"
                onChange={handleOnChangeFirstName}
                value={firstName}
              />
            </div>
            <div className="form-group">
              <ReactSelect
                value={taskerSkill}
                onChange={handleChangeSkill}
                options={skills.map((skill) => ({
                  value: skill,
                  label: skill,
                }))}
                placeholder="Skill/Trade"
              />
            </div>
            <div className="invite-tasker-phone-group">
              <div className="form-group phone-appendix">
                <ReactSelect
                  value={countryCode}
                  onChange={handleCountryCode}
                  options={countryCodeOptions}
                  styles={{
                    control: (styles) => ({
                      ...styles,
                      backgroundColor: "white",
                      width: 80,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      display: "flex",
                      flexDirection: "row",
                    }),
                  }}
                  components={{ Option }}
                />
              </div>
              <div className="form-group phone-number">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Phone Number"
                  onChange={handleOnChangePhoneNumber}
                  value={phoneNumber}
                />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-white"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-green"
              data-dismiss="modal"
              onClick={handleAddTasker}
              disabled={!firstName || !phoneNumber || !taskerSkill}
            >
              Invite
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InviteTaskerModal;



// WEBPACK FOOTER //
// ./src/components/InvitaeTakserModal/index.js